import http from '@/plugins/http-common'
import {OrderByVariants} from './constants'
import {ResponseData} from './types'

export type GetListParams = {
    limit: null | number,
    offset: null | number,
    order_by: null | OrderByVariants,
    sort_by: null | string,
    agent_id: null | number,
}

export type UpdateEarningHoldStatusParams = {
    earning_id: number,
    status_id: number
}

export type AddAccrualParams = {
    agent_id: number,
    amount: null | number,
    promotion: string,
    lead_id: number,
    hold_status: boolean
}

export type EditEarningParams = {
    earning_id: number,
    amount: number,
    promotion: string
}

class BalanceService {
    getList = (params: GetListParams): Promise<ResponseData> => http.get('/history', {params})
    updateEarningHoldStatus = (params: UpdateEarningHoldStatusParams): Promise<ResponseData> => http.post('/hold', params)
    addAccrual = (params: AddAccrualParams): Promise<ResponseData> => http.post('/accruals/create', params)
    editEarningAmount = (params: EditEarningParams): Promise<ResponseData> => http.post(`/history/${params.earning_id}/update`, params)
}

export default new BalanceService()
